import { gql } from '@apollo/client';

export default gql`
  mutation updateMSGTemplate(
    $_id: String
    $name: String
    $nameAr: String
    $msgtype: Int
    $subject: String
    $body: String
  ) {
    updateMSGTemplate(
      _id: $_id
      name: $name
      nameAr: $nameAr
      msgtype: $msgtype
      subject: $subject
      body: $body
    ) {
      ok
      message
      data
      error
    }
  }
`;
